import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconHandlingTuneup = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={21}
    fill="none"
    viewBox="0 0 24 21"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-handling-tuneup_svg__a)"
      d="M17.898 7.922a.971.971 0 0 1 0 1.445l-6.875 5.938c-.585.508-1.523.078-1.523-.742V11.28c-4.258.508-5.938 2.305-4.414 7.11.195.625-.547 1.132-1.094.742C2.273 17.883.75 15.5.75 13.117.75 7.961 4.422 6.36 9.5 5.97V2.727c0-.782.938-1.211 1.523-.704l6.875 5.899Zm5 0c.43.39.43 1.055 0 1.484l-6.875 5.899c-.585.508-1.523.078-1.523-.703v-.625l6.133-5.313L14.5 3.313v-.586c0-.782.938-1.211 1.523-.704l6.875 5.899Z"
    />
    <defs>
      <linearGradient
        id="icon-handling-tuneup_svg__a"
        x1={22}
        x2={3.025}
        y1={1}
        y2={20.974}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCF4BF" />
        <stop offset={0.18} stopColor="#EFC862" />
        <stop offset={0.73} stopColor="#CD9832" />
        <stop offset={1} stopColor="#BB811B" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconHandlingTuneup;
